import { NgModule } from '@angular/core';
import { SalesStoreModule } from './sales-store/sales-store.module';
import { StoreModule } from '@ngrx/store';
import * as fromState from '.';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '@environments/environment';
import { DashboardStoreModule } from './dashboard-store/dashboard-store.module';
import { SalesPlanStoreModule } from './sales-plan-store/sales-plan-store.module';
import { OrdersStoreModule } from './orders-store/orders-store.module';
import { CustomersStoreModule } from './customers-store/customers-store.module';
import { CatalogStoreModule } from './catalog-store/catalog-store.module';
import { CatalogPlanStoreModule } from './catalog-plan-store/catalog-plan-store.module';

@NgModule({
  declarations: [],
  imports: [
    StoreModule.forRoot(fromState.reducers, {
      metaReducers: fromState.metaReducers,
    }),
    EffectsModule.forRoot([]),
    SalesStoreModule,
    !environment.production ? StoreDevtoolsModule.instrument({connectInZone: true}) : [],
    DashboardStoreModule,
    SalesPlanStoreModule,
    OrdersStoreModule,
    CustomersStoreModule,
    CatalogStoreModule,
    CatalogPlanStoreModule,
  ],
})
export class RootStoreModule {}
